import { merge } from "lodash";
import { Geometry } from "@converge-collective/common/models/Event";
import { Theme } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { GoogleMapsApiKey } from "~/lib/config";
import GoogleMapReact from "google-map-react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mapContainer: {
      marginBottom: theme.spacing(2),
    },
    map: {
      overflow: "auto",
      height: 540,
      position: "relative",
      borderRadius: 8,
    },
  })
);

type Props = {
  geometry?: Geometry;
  containerStyles?: Record<string, any>;
  mapStyles?: Record<string, any>;
};
export default function EventMap({
  geometry,
  containerStyles,
  mapStyles,
}: Props): React.ReactElement {
  const classes = useStyles();

  const { viewport, location } = geometry || {};
  const { lat, lng } = location || {};
  const { north, south, east, west } = viewport || {};
  const defaultCenter = location && { lat, lng };
  const bounds = viewport && { north, south, east, west };

  const handleApiLoaded = (map: google.maps.Map, maps: any) => {
    console.log("handleApiLoaded Google map loaded", {
      map,
      maps,
      fitBounds: map.fitBounds,
    });
    if (north && south && east && west) {
      map.fitBounds({ north, south, east, west });
    }
    map.setMapTypeId;
  };

  const mapId = "79695cc310990814";

  const mapOptions = merge({
    bootstrapURLKeys: { key: GoogleMapsApiKey },
    options: { mapId },
    defaultCenter,
    bounds,
    zoom: 10,
    yesIWantToUseGoogleMapApiInternals: true,
    onGoogleApiLoaded: ({ map, maps }) => handleApiLoaded(map, maps),
  });

  console.log({ mapOptions });

  return (
    <div className={classes.mapContainer} style={containerStyles}>
      {defaultCenter && bounds && (
        <div className={classes.map} style={mapStyles}>
          {/* 
          // @ts-ignore: probably need to upgrade to latest React */}
          <GoogleMapReact {...mapOptions} />
        </div>
      )}
    </div>
  );
}
